module.exports = __webpack_public_path__ + "static/img/CarbonFootprint3.4ea8205d.png";